module.exports = __webpack_public_path__ + "img/16581246_L.664ebc78.png";